import React, { useEffect } from 'react';
import { CalendarIcon, MapPinIcon, ImageIcon, MessageSquareIcon, HelpCircleIcon, FileTextIcon, CheckSquareIcon, AlertTriangleIcon, ClockIcon, DollarSignIcon } from 'lucide-react';
interface TourNavigationProps {
  activeSection: string;
  setActiveSection: (section: string) => void;
}
export function TourNavigation({
  activeSection,
  setActiveSection
}: TourNavigationProps) {
  const navItems = [{
    id: 'description',
    label: 'Description',
    icon: <FileTextIcon size={18} data-id="element-2147" />
  }, {
    id: 'itinerary',
    label: 'Itinerary',
    icon: <ClockIcon size={18} data-id="element-2148" />
  }, {
    id: 'map',
    label: 'Tour Map',
    icon: <MapPinIcon size={18} data-id="element-2149" />
  }, {
    id: 'pricing',
    label: 'Price & Departures',
    icon: <DollarSignIcon size={18} data-id="element-2150" />
  }, {
    id: 'inclusions',
    label: 'Inclusions',
    icon: <CheckSquareIcon size={18} data-id="element-2151" />
  }, {
    id: 'important-info',
    label: 'Important Info',
    icon: <AlertTriangleIcon size={18} data-id="element-2152" />
  }, {
    id: 'gallery',
    label: 'Gallery',
    icon: <ImageIcon size={18} data-id="element-2153" />
  }, {
    id: 'reviews',
    label: 'Reviews',
    icon: <MessageSquareIcon size={18} data-id="element-2154" />
  }];
  // Handle scroll events to update active section
  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY + 100;
      // Find the section that is currently in view
      for (const item of navItems) {
        const element = document.getElementById(item.id);
        if (element) {
          const {
            offsetTop,
            offsetHeight
          } = element;
          if (scrollPosition >= offsetTop && scrollPosition < offsetTop + offsetHeight) {
            setActiveSection(item.id);
            break;
          }
        }
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [setActiveSection, navItems]);
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      window.scrollTo({
        top: element.offsetTop - 80,
        behavior: 'smooth'
      });
      setActiveSection(sectionId);
    }
  };
  return <nav className="w-full py-3 bg-white" data-id="element-2155">
      <div className="container mx-auto px-4" data-id="element-2156">
        <div className="flex overflow-x-auto hide-scrollbar space-x-1 sm:space-x-4 justify-start sm:justify-center" data-id="element-2157">
          {navItems.map(item => <button key={item.id} onClick={() => scrollToSection(item.id)} className={`flex items-center whitespace-nowrap px-3 py-2 rounded-md text-sm font-medium transition-colors
                ${activeSection === item.id ? 'bg-blue-100 text-blue-700' : 'text-gray-600 hover:text-gray-900 hover:bg-gray-100'}`} data-id="element-2158">
              <span className="mr-2" data-id="element-2159">{item.icon}</span>
              <span data-id="element-2160">{item.label}</span>
            </button>)}
        </div>
      </div>
    </nav>;
}